//====================================================
//  Function: Slider
//====================================================
function fn_components_slider(){
	fn_contact_slider();
	fn_testimonials_slider();
	fn_trust_us_slider();
	fn_classic_slider();
	fn_selected_products_slider();
	fn_blog_slider();
	fn_partners_slider();
	fn_configurator_slider();
	fn_graph_slider();
	fn_hologram_slider();
}


(function($) {
  'use strict';

  //create temporal object to get slick object
  var getSlick = function() {
	var $tmp = $('<div>').slick();
	var slick = $tmp[0].slick.constructor;
	$tmp.slick('unslick');
	return slick;
  };

  if ($.fn.slick) {
	var Slick = getSlick();
	if (Slick) {
	  //hook checkResponsive method
	  var checkResponsiveOrig = Slick.prototype.checkResponsive;
	  Slick.prototype.checkResponsive = function(initial, forceUpdate) {
		var _ = this;
		if (_.options.autoSlidesToShow && !_.options.infinite && _.options.variableWidth) {
		  var sliderWidth = _.$slider.width();
		  var width = 0, length = _.$slides.length;
		  for (var i = 0; i < length; i++) {
			width += $(_.$slides[i]).outerWidth();
		  }
		  _.averageSlidesWidth = width / length;
		  _.options.slidesToShow = Math.floor(sliderWidth / _.averageSlidesWidth) || 1;
		  //force update arrows
		  if (_.lastSlidesToShow !== _.options.slidesToShow) {
			_.lastSlidesToShow = _.options.slidesToShow;
			if (initial === true) {
			  _.currentSlide = _.options.initialSlide;
			}
			_.refresh(initial);
		  }
		}
		return checkResponsiveOrig.apply(this, arguments);
	  };
	  //hook getLeft method
	  var getLeftOrig = Slick.prototype.getLeft;
	  Slick.prototype.getLeft = function(slideIndex) {
		var _ = this;
		if (_.options.autoSlidesToShow && !_.options.infinite && _.options.variableWidth) {
		  var targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
		  if (targetSlide[0]) {
			var diff = 0;
			if (slideIndex) {
			  var sliderWidth = _.$slider.width();
			  var otherSlidesWidth = (_.slideCount - slideIndex) * _.averageSlidesWidth;
			  if (otherSlidesWidth < sliderWidth) {
				diff = sliderWidth - otherSlidesWidth;
			  }
			}
			return (targetSlide[0].offsetLeft - diff) * -1;
		  }
		  return  0;
		}
		return getLeftOrig.apply(this, arguments);
	  };
	}
  }
})(jQuery);



function fn_contact_slider(){
	if ($( '.js-slider-contact' ).length) {
		$( '.js-slider-contact' ).slick({
			infinite: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			autoplay: false,
			autoplaySpeed: 3000,
			cssEase: 'linear',
			fade: true,
			speed: 500,
			variableWidth: false,
			nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-right"></i></span>',
			prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-left"></i></span>',
			mobileFirst: true
		});

		$('.js-map-pin-item').click(function(){
			var inst = $(this);
			var pinId  = inst.attr( 'data-id' );
			$('.js-map-pin-item').removeClass( class_active );
			inst.addClass( class_active );
			$( '.js-slider-contact' ).slick('slickGoTo', pinId - 1);
		});

		$('.js-slider-contact').on('afterChange', function(event, slick, currentSlide, nextSlide){
			$( '.js-map-pin-item' ).eq(currentSlide).trigger( 'click' );
		});
	}
}

function fn_testimonials_slider(){
	if ($( '.js-slider-testimonial' ).length) {
		$( '.js-slider-testimonial' ).slick({
			infinite: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: false,
			autoplaySpeed: 3000,
			cssEase: 'linear',
			fade: true,
			speed: 500,
			variableWidth: false,
			nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-right"></i></span>',
			prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-left"></i></span>',
			mobileFirst: true
		});

		$('.js-testimonial-prev').bind( 'click' ,function(){
			$( '.js-slider-testimonial' ).slick('slickPrev');
		});

		$('.js-testimonial-next').bind( 'click' ,function(){
			$( '.js-slider-testimonial' ).slick('slickNext');
		});
		
	}
}

function fn_trust_us_slider(){
	if ($( '.js-slider-trust-us' ).length) {
		$( '.js-slider-trust-us' ).slick({
			infinite: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: false,
			autoplaySpeed: 3000,
			cssEase: 'linear',
			// fade: true,
			speed: 500,
			variableWidth: false,
			nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-right"></i></span>',
			prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-left"></i></span>',
			mobileFirst: true
		});

		$('.js-trust-us-prev').bind( 'click' ,function(){
			$( '.js-slider-trust-us' ).slick('slickPrev');
		});

		$('.js-trust-us-next').bind( 'click' ,function(){
			$( '.js-slider-trust-us' ).slick('slickNext');
		});

		$('.js-partner-image').click(function(){
			var inst = $(this);
			var partnerId  = inst.attr( 'data-id' );
			$('.js-partner-image').removeClass( class_active );
			inst.addClass( class_active );
			$( '.js-slider-trust-us' ).slick('slickGoTo', partnerId - 1);
		});

		$('.js-slider-trust-us').on('afterChange', function(event, slick, currentSlide, nextSlide){
			$( '.js-partner-image' ).removeClass(class_active);
			$( '.js-partner-image' ).eq(currentSlide).addClass(class_active);
		});
		
	}
}

function fn_classic_slider(){
	if ($( '.js-slider-classic' ).length) {
		$( '.js-slider-classic' ).slick({
			infinite: true,
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: false,
			autoplaySpeed: 3000,
			cssEase: 'linear',
			fade: true,
			speed: 500,
			variableWidth: false,
			nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-right"></i></span>',
			prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-left"></i></span>',
			mobileFirst: true
		});
	}
}


var sliderProductLength;

function fn_selected_products_slider(){
	if ($( '.js-slider-selected-products' ).length) {
		
		$('.js-slider-selected-products').on('init', function(event, slick, currentSlide, nextSlide){
			sliderProductLength = slick.slideCount;
			// console.log("init " + sliderProductLength);
		});

		$( '.js-slider-selected-products' ).slick({
			infinite: false,
			dots: false,
			arrows: true,
			autoplay: false,
			autoplaySpeed: 3000,
			cssEase: 'linear',
			// fade: true,
			speed: 500,
			variableWidth: true,
			autoSlidesToShow: true,
			nextArrow: '<span class="slick-arrows slick-arrows-classic slick-next"><i class="icon icon-chevron-right"></i></span>',
			prevArrow: '<span class="slick-arrows slick-arrows-classic slick-prev"><i class="icon icon-chevron-left"></i></span>',
			mobileFirst: true,
		});

		if (sliderProductLength == 0){
			$('.selected-products').addClass('d-none');
		}

		if (sliderProductLength > 1) {
			$('.selected-products').removeClass('slider-product-length-1 slider-product-length-2 slider-product-length-3 slider-product-length-4');
			$('.selected-products').addClass('slider-product-length-' + sliderProductLength);
			$('.js-slider-selected-products').slick("slickSetOption", "variableWidth", true, true);
		} else {
			$('.selected-products').removeClass('slider-product-length-1 slider-product-length-2 slider-product-length-3 slider-product-length-4');
			$('.selected-products').addClass('slider-product-length-' + sliderProductLength);
			$('.js-slider-selected-products').slick("slickSetOption", "variableWidth", false, true);
		}


		$('.js-slider-selected-products').on('afterChange', function(event, slick, currentSlide, nextSlide){
			if (slick.slideCount == 0) {
				$('.selected-products').addClass('d-none');
				return false;
			}
			if (slick.slideCount > 1) {
				$('.selected-products').removeClass('slider-product-length-1 slider-product-length-2 slider-product-length-3 slider-product-length-4');
				$('.selected-products').addClass('slider-product-length-' + slick.slideCount);
				$('.js-slider-selected-products').slick("slickSetOption", "variableWidth", true, true);
			} else {
				$('.selected-products').removeClass('slider-product-length-1 slider-product-length-2 slider-product-length-3 slider-product-length-4');
				$('.selected-products').addClass('slider-product-length-' + slick.slideCount);
				$('.js-slider-selected-products').slick("slickSetOption", "variableWidth", false, true);
			}
		});
	}

	$(document).on('click','.js-remove-slide', function() {
		var slide = $('.js-slider-selected-products .slick-current').index();
		$('.js-slider-selected-products').slick('slickRemove', slide, false).slick('refresh');
		$( '.js-close-modal' ).trigger( 'click' );
	});

}



function fn_partners_slider(){
	if ($( '.js-slider-partners' ).length) {
		$( '.js-slider-partners' ).slick({
			infinite: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 2500,
			// cssEase: 'linear',
			speed: 500,
			variableWidth: true,
			pauseOnHover: false,
			pauseOnFocus: false,
			nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-right"></i></span>',
			prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-left"></i></span>',
			mobileFirst: true
		});
	}
}

function fn_configurator_slider(){
	if ($( '.js-slider-configurator' ).length) {
		$( '.js-slider-configurator' ).slick({
			infinite: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			autoplay: false,
			autoplaySpeed: 3000,
			cssEase: 'linear',
			speed: 500,
			variableWidth: false,
			asNavFor:  '.js-slider-configurator-content',
			nextArrow: '<span class="slick-arrows slick-arrows-bottom slick-next"><i class="icon icon-chevron-right"></i></span>',
			prevArrow: '<span class="slick-arrows slick-arrows-bottom slick-prev"><i class="icon icon-chevron-left"></i></span>',
			mobileFirst: true
		});
	}

	if ($( '.js-slider-configurator-content' ).length) {
		$( '.js-slider-configurator-content' ).slick({
			infinite: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: false,
			autoplaySpeed: 3000,
			cssEase: 'linear',
			speed: 500,
			fade: true,
			variableWidth: false,
			touchMove: false,
			swipeToSlide: false,
			swipe: false,
			draggable: false,
			asNavFor:  '.js-slider-configurator',
			nextArrow: '<span class="slick-arrows slick-arrows-bottom slick-next"><i class="icon icon-chevron-right"></i></span>',
			prevArrow: '<span class="slick-arrows slick-arrows-bottom slick-prev"><i class="icon icon-chevron-left"></i></span>',
			mobileFirst: true
		});
	}
}

function fn_graph_slider(){
	if ($( '.js-slider-graph' ).length) {
		$( '.js-slider-graph' ).slick({
			infinite: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			autoplay: false,
			autoplaySpeed: 3000,
			cssEase: 'linear',
			speed: 500,
			variableWidth: false,
			asNavFor:  '.js-slider-graph-content',
			nextArrow: '<span class="slick-arrows slick-arrows-bottom-ext slick-next"><i class="icon icon-chevron-right"></i></span>',
			prevArrow: '<span class="slick-arrows slick-arrows-bottom-ext slick-prev"><i class="icon icon-chevron-left"></i></span>',
			mobileFirst: true
		});
	}

	if ($( '.js-slider-graph-content' ).length) {
		$( '.js-slider-graph-content' ).slick({
			infinite: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: false,
			autoplaySpeed: 3000,
			cssEase: 'linear',
			speed: 500,
			fade: true,
			variableWidth: false,
			touchMove: false,
			swipeToSlide: false,
			swipe: false,
			draggable: false,
			asNavFor:  '.js-slider-graph',
			nextArrow: '<span class="slick-arrows slick-arrows-bottom-ext slick-next"><i class="icon icon-chevron-right"></i></span>',
			prevArrow: '<span class="slick-arrows slick-arrows-bottom-ext slick-prev"><i class="icon icon-chevron-left"></i></span>',
			mobileFirst: true
		});
	}
}

function fn_blog_slider(){
	if ($( '.js-slider-blog' ).length) {
		$( '.js-slider-blog' ).slick({
			infinite: true,
			dots: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: false,
			autoplay: false,
			autoplaySpeed: 3000,
			cssEase: 'linear',
			speed: 500,
			variableWidth: false,
			nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-right"></i></span>',
			prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-left"></i></span>',
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 1220,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 560,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 400,
					settings: {
						slidesToShow: 1,
					}
				},
				{
					breakpoint: 200,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});
	}
}



function fn_hologram_slider(){
	if ($( '.js-slider-hologram' ).length) {
		$( '.js-slider-hologram' ).slick({
			infinite: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: false,
			autoplaySpeed: 3000,
			cssEase: 'linear',
			// fade: true,
			speed: 500,
			variableWidth: false,
			nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-right"></i></span>',
			prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-left"></i></span>',
			mobileFirst: true
		});

		$('.js-hologram-select').click(function(){
			var inst = $(this);
			var hologramItem  = inst.attr( 'data-id' );
			$('.js-hologram-select').removeClass( class_active );
			inst.addClass( class_active );
			$( '.js-slider-hologram' ).slick('slickGoTo', hologramItem - 1);
		});

		$('.js-slider-hologram').on('afterChange', function(event, slick, currentSlide, nextSlide){
			$( '.js-hologram-select' ).eq(currentSlide).trigger( 'click' );
		});
	}
}